import * as React from 'react';
import { Button } from '@chakra-ui/react';
import { InfoTip, Tooltip } from '@ui';
import { AiOutlineExport } from 'react-icons/ai';
import type { MultipleTabsOpenButtonProps } from '../types';
import { open } from './open';

export const openButton: React.FC<MultipleTabsOpenButtonProps> = ({
  pdfItems,
  buttonLabel = 'Open Multiple PDFs',
  buttonIcon = <AiOutlineExport />,
  disabled = false,
  isInfoTip = true,
  config,
  ...buttonProps
}) => {
  const handleOpen = React.useCallback(() => {
    open(pdfItems, config);
  }, [pdfItems, config]);

  const hasValidPdfs = pdfItems && pdfItems.some((item) => item.url);

  return (
    <Tooltip content={!disabled && hasValidPdfs ? '' : 'No PDFs to open'}>
      <Button
        aria-label="open-multiple-pdfs-in-new-tabs"
        onClick={handleOpen}
        variant="outline"
        color="tertiary.fg"
        size="sm"
        {...buttonProps}
        disabled={disabled || !hasValidPdfs}
      >
        {buttonIcon}
        {buttonLabel}
      </Button>
      {isInfoTip && (
        <InfoTip>"Will open multiple PDFs in separate tabs"</InfoTip>
      )}
    </Tooltip>
  );
};
